import $ from 'jquery';

import {
  bindClearButton,
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  form: $(`#warehouse_product_search`),
  dropdowns: $(`#warehouse_product_search select`),
  clearButton: $(`#warehouse_product_search #clear-button`),
};

export default class SearchWarehouseProductsService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.bindElements();
  }

  static init() {
    if ($(`.warehouse_trading_partner_variants.new`).length === 0) {
      return undefined;
    }

    return new SearchWarehouseProductsService();
  }

  bindElements() {
    bindSearchDropdowns(this.searchFormElements);
    bindClearButton(this.searchFormElements);
  }
}
